import React, { useState } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import DatePickerField from "../../Components/DatePickerField";
import moment from "moment";
import { apiEndPoints } from "../../constants/apiEndPoints";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UpdateCodeReview = ({ record, onUpdate, onUpdateFunction }) => {
  const [editedRecord, setEditedRecord] = useState({
    ...record,
    year: new Date(record.year.toString()),
  });

  const [showValidation, setShowValidation] = useState({
    monthCycleError: "",
    reviewError: "",
    codeReusabilityError: "",
    codingStandardError: "",
    devOpsError: "",
    devOpsToolError: "",
    reviewerError: "",
    commentError: "",
  });

  const handleFieldChange = (fieldName, value) => {
    const updatedRecord = { ...editedRecord };
    if (fieldName === "dateformat") {
      updatedRecord.date = formatDateToYYYYMMDD(value);
    } else {
      updatedRecord[fieldName] = value;
    }

    const newValidationState = { ...showValidation };

    if (fieldName === "monthCycle") {
      newValidationState.monthCycleError = value
        ? ""
        : "This field is required.";
    } else if (fieldName === "review") {
      newValidationState.reviewError = value ? "" : "This field is required.";
    } else if (fieldName === "codeReusability") {
      newValidationState.codeReusabilityError = value
        ? ""
        : "This field is required.";
    } else if (fieldName === "codingStandard") {
      newValidationState.codingStandardError = value
        ? ""
        : "This field is required.";
    } else if (fieldName === "devOps") {
      newValidationState.devOpsError = value ? "" : "This field is required.";
    } else if (fieldName === "devOpsTool") {
      newValidationState.devOpsToolError = value
        ? ""
        : "This field is required.";
    } else if (fieldName === "reviewer") {
      newValidationState.reviewerError = value ? "" : "This field is required.";
    } else if (fieldName === "comment") {
      newValidationState.commentError = value ? "" : "This field is required.";
    }
    setShowValidation(newValidationState);
    setEditedRecord(updatedRecord);
  };

  const formatDateToYYYYMMDD = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleUpdate = async () => {
    const isFormValid = Object.values(showValidation).every(
      (error) => error === ""
    );
    if (!isFormValid) {
      return;
    }
    try {
      const employeeName = sessionStorage.getItem("employeeName");
      const response = await axios.put(apiEndPoints.updateCodeReviewRecord, {
        ...editedRecord,
        year: editedRecord?.year.getFullYear(),
        username: employeeName,
      });
      if (response.status === 200) {
        toast.success("Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000, // Adjust as needed
        });
        onUpdateFunction();
        onUpdate();
      }
    } catch (error) {}
  };

  const handleOnChange = (date) => {
    setEditedRecord((state) => ({
      ...state,
      reviewDate: moment(date).format("YYYY-MM-DD"),
    }));
  };

  return (
    <Modal
      className="modal fade bd-example-modal-lg"
      show={true}
      onHide={onUpdate}
      centered
      size="lg"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title>Update Code Review</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Form style={{ width: "100%" }}>
          <div className="row">
            <Form.Group
              className="form-group col-md-4"
              controlId="departmentName"
            >
              <Form.Label>Department Name:</Form.Label>
              <Form.Control
                disabled
                type="text"
                value={editedRecord.departmentName}
                onChange={(e) =>
                  handleFieldChange("departmentName", e.target.value)
                }
              />
            </Form.Group>
            <Form.Group
              className="form-group col-md-4"
              controlId="azureProjectName"
            >
              <Form.Label>Project Name:</Form.Label>
              <Form.Control
                disabled
                type="text"
                value={editedRecord.azureProjectName}
                onChange={(e) =>
                  handleFieldChange("azureProjectName", e.target.value)
                }
              />
            </Form.Group>
            <DatePickerField
              disabled
              className="form-control"
              label="Year:"
              type="year"
              showYearPicker
              selected={editedRecord?.year ?? new Date()}
              dateFormat="yyyy"
              onChange={(year) => handleFieldChange("year", year)}
            />
          </div>
          <div className="row">
            <Form.Group className="form-group col-md-4" controlId="monthCycle">
              <Form.Label>Quarter:</Form.Label>
              <Form.Control
                // disabled
                as="select"
                value={editedRecord.monthCycle}
                className={showValidation.monthCycleError ? "invalid" : ""}
                onChange={(e) =>
                  handleFieldChange("monthCycle", e.target.value)
                }
              >
                <option value="Jan-Mar">Jan-Mar</option>
                <option value="Apr-Jun">Apr-Jun</option>
                <option value="July-Sep">July-Sep</option>
                <option value="Oct-Dec">Oct-Dec</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-group col-md-4" controlId="review">
              <Form.Label>Code Review:</Form.Label>
              <Form.Control
                as="select"
                value={editedRecord.review}
                className={showValidation.reviewError ? "invalid" : ""}
                onChange={(e) => handleFieldChange("review", e.target.value)}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="N/A">N/A</option>
              </Form.Control>
            </Form.Group>
            <Form.Group
              className="form-group col-md-4"
              controlId="codeReusability"
            >
              <Form.Label>Code Reusability:</Form.Label>
              <Form.Control
                as="select"
                value={editedRecord.codeReusability}
                className={showValidation.codeReusabilityError ? "invalid" : ""}
                onChange={(e) =>
                  handleFieldChange("codeReusability", e.target.value)
                }
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="N/A">N/A</option>
              </Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group
              className="form-group col-md-4"
              controlId="codingStandard"
            >
              <Form.Label>Coding Standard:</Form.Label>
              <Form.Control
                value={editedRecord.codingStandard}
                className={showValidation.codingStandardError ? "invalid" : ""}
                onChange={(e) =>
                  handleFieldChange("codingStandard", e.target.value)
                }
              />
            </Form.Group>
            <Form.Group className="form-group col-md-4" controlId="devOps">
              <Form.Label>DevOps:</Form.Label>
              <Form.Control
                as="select"
                value={editedRecord.devOps}
                className={showValidation.devOpsError ? "invalid" : ""}
                onChange={(e) => handleFieldChange("devOps", e.target.value)}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
                <option value="N/A">N/A</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="form-group col-md-4" controlId="devOpsTool">
              <Form.Label>DevOps Tool:</Form.Label>
              <Form.Control
                as="select"
                value={editedRecord.devOpsTool}
                className={showValidation.devOpsToolError ? "invalid" : ""}
                onChange={(e) =>
                  handleFieldChange("devOpsTool", e.target.value)
                }
              >
                <option value="DevOps">DevOps</option>
                <option value="GIT">GIT</option>
                <option value="SVN">SVN</option>
                <option value="Other">Other</option>
                <option value="N/A">N/A</option>
              </Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <DatePickerField
              className="form-control"
              label="Review Date:"
              onChange={(date) => handleOnChange(date)}
              value={editedRecord.reviewDate}
              dateFormat="yyyy-mm-dd"
            />
            <Form.Group className="form-group col-md-4" controlId="reviewer">
              <Form.Label>Reviewer:</Form.Label>
              <Form.Control
                value={editedRecord.reviewer}
                className={showValidation.reviewerError ? "invalid" : ""}
                onChange={(e) => handleFieldChange("reviewer", e.target.value)}
              />
            </Form.Group>
            <Form.Group className="form-group col-md-4" controlId="comment">
              <Form.Label>Comment:</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                value={editedRecord.comment}
                className={showValidation.commentError ? "invalid" : ""}
                onChange={(e) => handleFieldChange("comment", e.target.value)}
              />
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleUpdate}>
          Update
        </Button>
        <Button variant="secondary" onClick={onUpdate}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateCodeReview;
